//const _BASE = 'https://huaxin.yuanqiwulian.com/newbuilt/common/ajax.xhtml?to=';
//const _BASE = '/newbuilt/common/ajax.xhtml?to=';
const _BASE ='https://hnsb.slzyun.com/hniot/';
//const _BASE = '/iot/';
const _URL = {
    login:`${_BASE}user/login`,  //用户登录
	getUserInfo:`${_BASE}user/getUserInfo`,  //获取用户信息
    loginsj  : `${_BASE}loginsj`,    //登录
    dictionarysj  : `${_BASE}dictionarysj`,    //获取字典
    bmlist  : `${_BASE}bmlist`,    //获取专业
    bzlist  : `${_BASE}bzlist`,    //获取被检查单位
    uploadify  : `${_BASE}upload/file`,    //图片上传
    zdxcSave: `${_BASE}yhsb/save`,    //上报
    gsYhglxflist: `${_BASE}yhsb/findAll`,    //巡检列表
    yhsbDetail: `${_BASE}yhsb/findById`,    //巡检基本信息
    yhsbfkrjelist: `${_BASE}yhsbfkrjelist`,    //巡检罚款人信息
    yhsbzblist: `${_BASE}/yhsbZb/findAll`,    //巡检附件
    yhsbzgfjlist: `${_BASE}yhsbzgfjlist`,    //巡检附件
    userList: `${_BASE}userList`,    //人员列表
    yhsbxfSave: `${_BASE}yhsbxfSave`,    //巡检下发
    gsYhglzglist: `${_BASE}gsYhglzglist`,    //我的整改列表
    yhsbzgSave: `${_BASE}yhsbzgSave`,    //进行整改
    yhsbyqSave: `${_BASE}yhsbyqSave`,    //延期提交
    yhsbspSave: `${_BASE}yhsbspSave`,    //延期审批
    yhsbysSave: `${_BASE}yhsbysSave`,    //整改验收
    updateUserPassword: `${_BASE}user/updatePasswordSj`,    //修改密码
    gsYhglgdlist: `${_BASE}gsYhglgdlist`,    //归档列表
    jsXxlist: `${_BASE}wzgl/findAll`,    //未读消息
    jsXxlistAll: `${_BASE}wzgl/findAll`,    //所有消息
    xxReadSave: `${_BASE}wzgl/updateOne`,    //消息已读
    sbList: `${_BASE}recruit/findAll`,    //设备信息
    orderList: `${_BASE}zOrder/findAll`,    //设备信息
	zzjgList:`${_BASE}school/findAllList`,  //获取所有专业
    fileUrl:_BASE
};
export default _URL